import {preloader} from './preloader';
import RapidImageHover from './menu';

// Main element
const imagesMainEl = document.querySelector('.js-images');
if (imagesMainEl) {

    // Preload the images set as data attrs in the menu items
    preloader('.js-image').then(() => {

        // initialize menu
        new RapidImageHover(imagesMainEl);

    });
}
